var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Personaliser---Necklaces",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Necklaces---Customiser---main-screen---mais-op\\xE7\\xF5es---topo---lightbox",
    transform: "translate(-228.000000, -187.000000)",
    fill: "#37584F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(-37.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(117.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.787841,4.13269231 L158.155341,3.38638462 C158.251136,3.1915 158.251136,2.962 158.155341,2.76711538 L157.473523,1.3825 C157.357955,1.14815385 157.122045,1 156.863636,1 L154.136364,1 C153.878295,1 153.642045,1.14815385 153.526477,1.3825 L152.844659,2.76711538 C152.748864,2.962 152.748864,3.1915 152.844659,3.38638462 L153.212159,4.13269231 C150.192386,5.1175 148,7.99542308 148,11.3846154 C148,15.5838077 151.364432,19 155.5,19 C159.635568,19 163,15.5838077 163,11.3846154 C163,7.99542308 160.807614,5.1175 157.787841,4.13269231 Z M155.5,17.6153846 C152.116477,17.6153846 149.363636,14.8201923 149.363636,11.3846154 C149.363636,7.94903846 152.116477,5.15384615 155.5,5.15384615 C158.883523,5.15384615 161.636364,7.94903846 161.636364,11.3846154 C161.636364,14.8201923 158.883523,17.6153846 155.5,17.6153846 Z",
    id: "Shape"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.b1239ae6d00a30c103ec3eecfd3e35d9.svg";
export { ForwardRef as ReactComponent };